const GUEST_KEY = "mt_guest_id";
const DRAFT_KEY = "mt_inventory_draft";

export function getGuestId() {
  let id = localStorage.getItem(GUEST_KEY);
  if (!id || !/^[a-f0-9]{32}$/.test(id)) {
    id = Array.from(crypto.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");
    localStorage.setItem(GUEST_KEY, id);
  }
  return id;
}

export function loadDraft() {
  try { return JSON.parse(localStorage.getItem(DRAFT_KEY) || "null"); } catch { return null; }
}

export function saveDraft(inv) {
  if (inv?.rooms?.length) localStorage.setItem(DRAFT_KEY, JSON.stringify(inv));
  else localStorage.removeItem(DRAFT_KEY);
}

export const clearDraft = () => localStorage.removeItem(DRAFT_KEY);

export function remapDraftPaths(inv, mapping) {
  const m = (p) => mapping[p] || p;
  return {
    ...inv,
    videos: (inv.videos || []).map((v) => ({ ...v, path: m(v.path) })),
    video_path: inv.video_path ? m(inv.video_path) : inv.video_path,
    rooms: inv.rooms.map((r) => ({
      ...r,
      ...(r.source_video ? { source_video: m(r.source_video) } : {}),
      items: r.items.map((it) => (it.source_video ? { ...it, source_video: m(it.source_video) } : it)),
    })),
  };
}
